import { useState } from "react";
import { CustomComponentProps } from "utils/types/general.types";
import { deletedPNG } from "utils/assets_exports/images";
import ImageViewer from "./ImageViewer";

export type PostImageProps = CustomComponentProps & {
    img: string;
};

const PostImage = ({ img, className, style }: PostImageProps) => {
    const [open, setOpen] = useState(false);
    const [deleted, setDeleted] = useState(false);
    return (
        <>
            <div
                className={`relative w-full h-full ${className}`}
                style={style}
            >
                <img
                    src={img}
                    alt="post-image"
                    style={{ borderRadius: "0.75rem" }}
                />
                {deleted && (
                    <div className="post-image-overlay-1 flex w-full h-full justify-center items-center">
                        <img
                            src={deletedPNG}
                            alt="deleted icon"
                            className="w-1/2 delete-png"
                        />
                    </div>
                )}
                <div className="post-image-overlay w-full h-full flex flex-col gap-3 justify-center items-center">
                    <button
                        className={`bg-momeento-50 text-white text-center rounded-full w-fit px-3 py-1`}
                        onClick={() => setOpen(true)}
                    >
                        View
                    </button>

                    <button
                        className={`${deleted ? "bg-momeento-50" : "bg-red-600"} text-white text-center rounded-full w-fit px-3 py-1`}
                        onClick={() => setDeleted(!deleted)}
                    >
                        {deleted ? "Restore" : "Delete"}
                    </button>
                </div>
            </div>
            <ImageViewer
                img={img}
                deleted={deleted}
                setDeleted={setDeleted}
                open={open}
                setOpen={setOpen}
            />
        </>
    );
};

export default PostImage;
